<!-- MARK: SPECS -->
<app-section sectionTitle="Specs">
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; flex-direction: row; gap: 8px; flex-wrap: wrap">
      <button mat-fab extended color="primary" matTooltip="Save the Spec Levels" [disabled]="this.craftCalculatorStateService.disableButtons() || !afmBeService.userHasMasterpieceEntitlement()" (click)="saveSpecs()">Save Specs</button>
      <button
        mat-fab
        extended
        color="primary"
        matTooltip="Load the Spec Levels"
        [disabled]="this.craftCalculatorStateService.disableButtons() || !afmBeService.userHasMasterpieceEntitlement()"
        (click)="this.craftCalculatorStateService.loadSpecs()"
      >
        Load Specs
      </button>
    </div>

    @if (!afmBeService.userHasMasterpieceEntitlement()) {
      <p style="margin-top: 1px; font-size: 0.7rem; opacity: 0.65; margin-bottom: 0; margin-left: 3px">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; margin-right: 3px">info</mat-icon>
        Requires <a routerLink="/support-us">Masterpiece</a> Support
      </p>
    }
    <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 16px">
      @if (craftCalculatorStateService.craftGroup().allCraftAchievementsUnique().length === 0) {
        <p>The currently added crafts don't use any specs.</p>
      }
      @for (spec of craftCalculatorStateService.craftGroup().allCraftAchievementsUnique(); track $index) {
        <div style="display: flex; align-items: center">
          <img style="width: 75px; height: 75px" [src]="albionImageService.getDestinyBoardImageUrl(spec.id)" [alt]="spec.localizedName" [matTooltip]="spec.localizedName" />
          <div>
            <mat-form-field style="max-width: 240px">
              <mat-label style="font-size: 12px"> {{ spec.localizedName }}</mat-label>
              <input matInput type="number" step="1" min="0" max="100" [(ngModel)]="spec.playerLevel" (change)="this.craftCalculatorStateService.forceFocusTrigger()" />
            </mat-form-field>
          </div>
        </div>
      }
    </div>
  </div>
</app-section>
